<template>
    <div>

        <v-dialog v-model="loading.estado" :width="loading.ancho"  persistent>
            <v-card :color="loading.colorDialog" dark>
                <v-card-text class="pt-2 text-center">
                    {{ loading.titulo }}
                <v-progress-linear indeterminate  :color="loading.color"  class="mb-0" >
                </v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
    import { mapState} from 'vuex';
    export default {

        mounted() {
            // console.log("ENTRO LOADING")
        },

        data: () => ({
            name:'mensaje',
            estado: true
        }),


        computed: {
            ...mapState(["loading"]),
        },

    }
</script>
